@if(store.breadcrumbs().length > 0){

<div class="breadcrumb-container">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li>
        <a routerLink="/"><span class="fas fa-home"></span></a>
      </li>
      <li><span class="fas fa-chevron-right"></span></li>
      @for(breadcrumb of store.breadcrumbs(); track $index; let last = $last){
      <li
        class="breadcrumb-item"
        [class.active]="!!breadcrumb.url"
        [attr.aria-current]="!breadcrumb.url ? 'page' : null"
      >
        @if(breadcrumb.url){
        <a [routerLink]="breadcrumb.url" [queryParams]="breadcrumb.queryParams">{{
          breadcrumb.text | translate
        }}</a>
        } @else{
        {{ breadcrumb.text | translate }}
        }
      </li>
      @if(!last){
      <li><span class="fas fa-chevron-right"></span></li>
      } }
    </ol>
  </nav>
</div>

}
